import React, { useEffect, useState } from 'react';
import {
   Box,
   Grid,
   IconButton,
   Paper,
   Tooltip,
   Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MaterialTable from 'material-table';
import { headerStyle, tableIcons } from '../../../configs/ui/TableConfig';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimesCircle } from '@fortawesome/pro-light-svg-icons/faTimesCircle';
import Axios from 'axios';
import LoadingPopup from '../../Loading/LoadingPopup';
import ErrorPopup from '../../Error/ErrorPopup';
import {
   faFileEdit,
   faMinusCircle,
   faPlusCircle,
   faTrashAlt,
} from '@fortawesome/pro-duotone-svg-icons';
import { LogToBackend } from '../../../configs/helpers/LogToBackend';

const useStyles = makeStyles((theme) => ({
   paper: {
      // backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      // backgroundColor: "#fff",
      width: '75%',
      borderRadius: '7.5px',
      maxHeight: '95vh',
      overflow: 'auto',
   },
   role: {
      color: '#5858FA',
   },
   title: {
      color: '#6E6E6E',
   },
   large: {
      width: theme.spacing(8),
      height: theme.spacing(8),
   },
   header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignContent: 'center',
      alignItems: 'center',
      margin: theme.spacing(1, 0),
   },
   content: {
      margin: theme.spacing(0, 1),
      width: '100%',
   },
   headerL: {
      margin: theme.spacing(1),
   },
}));

const ViewTable = (props) => {
   const classes = useStyles();
   const [isLoading, setIsLoading] = useState(false);
   const [isError, setIsError] = useState({
      error: false,
      errorStatus: '',
      errorMessage: '',
   });
   const [resp, setResp] = useState(null);
   const [data, setData] = useState({
      ruleCode: '',
      ruleName: '',
      ruleCondition: '',
      ruleReferenceDescription: '',
      activityInRules: [],
   });

   useEffect(() => {
      getData();
   }, []);
   const getData = () => {
      setIsLoading(true);
      Axios.post('/GSB/dashboard/rule/GetRule', {
         ruleId: props.refID,
      })
         .then((response) => {
            setResp(response.data);
         })
         .catch((e) => {
            LogToBackend(e);
            setIsError({
               error: true,
               errorStatus: e.response.status,
               errorMessage: e.response.data.errorAppMessageTh
                  ? e.response.data.errorAppMessageTh
                  : 'เกิดข้อผิดพลาด',
            });
         })
         .finally(() => {
            setIsLoading(false);
         });
   };
   useEffect(() => {
      const transformRelateEmployees = async (relatedEmployees) => {
         let result = [];
         for (let i = 0; i < relatedEmployees.length; i++) {
            try {
               result.push(
                  (
                     await Axios.get(
                        `/GSB/dashboard/user/SearchEmployee?keyword=${relatedEmployees[i].employeeId}`,
                     )
                  ).data[0],
               );
            } catch (e) {
               console.log(e);
            }
         }
         return result;
      };

      if (resp) {
         (async () => {
            setData({
               ...resp,
               ruleName: resp.ruleNameTh,
               ruleCondition: resp.ruleConditionTh,
               activityInRules: resp.activityInRules.map((value) => {
                  return Object.assign(
                     {},
                     {
                        ...value,
                     },
                  );
               }),
               relatedPersons: await transformRelateEmployees(
                  resp.relatedEmployees,
               ),
            });
            setIsLoading(false);
         })();
      }
   }, [resp]);

   // useEffect(() => {
   //   console.log(data)
   // }, [data])

   const handleEdit = () => {
      props.onClickEdit(data);
   };
   const handleDelete = () => {
      props.onClickDelete(data);
   };
   const handleIncrease = () => {
      props.onClickIncrease(data);
   };
   const handleDecrease = () => {
      props.onClickDecrease(data);
   };
   if (isLoading) return <LoadingPopup />;
   if (isError.error)
      return (
         <ErrorPopup
            onClick={props.onClickClose}
            errorStatus={isError.errorStatus}
            errorMessage={isError.errorMessage}
         />
      );
   return (
      <Paper className={classes.paper}>
         <div className={classes.header}>
            <Box
               display={'flex'}
               justifyContent={'center'}
               alignItems={'center'}
               alignContent={'center'}
            >
               <Typography variant='h4'>รายละเอียดหลักเกณฑ์</Typography>
               <Tooltip title='แก้ไข'>
                  <IconButton aria-label='Edit' onClick={handleEdit}>
                     <FontAwesomeIcon color={'#00a2e8'} icon={faFileEdit} />
                  </IconButton>
               </Tooltip>
               <Tooltip title='ลบ'>
                  <IconButton aria-label='Delete' onClick={handleDelete}>
                     <FontAwesomeIcon color={'#ed1c24'} icon={faTrashAlt} />
                  </IconButton>
               </Tooltip>
               <Tooltip title='เพิ่ม'>
                  <IconButton aria-label='Increase' onClick={handleIncrease}>
                     <FontAwesomeIcon color={'#22b14c'} icon={faPlusCircle} />
                  </IconButton>
               </Tooltip>
               <Tooltip title='ลด'>
                  <IconButton aria-label='Decrease' onClick={handleDecrease}>
                     <FontAwesomeIcon color={'#ff7f27'} icon={faMinusCircle} />
                  </IconButton>
               </Tooltip>
            </Box>
            <IconButton
               className={classes.headerL}
               size='small'
               onClick={props.onClickClose}
            >
               <FontAwesomeIcon icon={faTimesCircle} />
            </IconButton>
         </div>
         <Box display='flex' alignItems='flex-start' flexDirection='column'>
            <Box m={1} fontSize={20}>
               <Grid container>
                  <Grid item xs={5}>
                     รหัสหลักเกณฑ์
                  </Grid>
                  <Grid item xs={7}>
                     {data.ruleCode}
                  </Grid>
                  <Grid item xs={5}>
                     ชื่อหลักเกณฑ์
                  </Grid>
                  <Grid item xs={7}>
                     {data.ruleName}
                  </Grid>
                  <Grid item xs={5}>
                     เงื่อนไขการได้รับคะแนน
                  </Grid>
                  <Grid item xs={7}>
                     {data.ruleCondition}
                  </Grid>
                  <Grid item xs={5}>
                     แหล่งที่มาข้อมูล
                  </Grid>
                  <Grid item xs={7}>
                     {data.ruleReferenceDescription}
                  </Grid>
               </Grid>
            </Box>
            <Box>
               <MaterialTable
                  title={'กิจกรรมที่อยู่ภายใต้หลักเกณฑ์'}
                  isLoading={isLoading}
                  columns={[
                     {
                        field: 'activityCode',
                        title: 'รหัสกิจกรรม',
                     },
                     {
                        field: 'activityName',
                        title: 'ชื่อกิจกรรม',
                        render: (rowData) => rowData.activityNameTh,
                     },
                     {
                        field: 'activityOwnerName',
                        title: 'เจ้าของกิจกรรม',
                        render: (rowData) => rowData.activityOwnerNameTh,
                     },
                     {
                        field: 'formatedAffordPoint',
                        title: 'จำนวนคะแนนที่ให้แล้ว',
                        type: 'numeric',
                     },
                     {
                        field: 'participantAmount',
                        title: 'จำนวนคน',
                        type: 'numeric',
                     },
                     {
                        field: 'during',
                        title: 'ระยะเวลา',
                        type: 'datetime',
                        render: (rowData) =>
                           `${dayjs(new Date(rowData.activityStartDate)).format(
                              'DD/MM/BBBB HH:mm',
                           )} - ${dayjs(
                              new Date(rowData.activityEndDate),
                           ).format('DD/MM/BBBB HH:mm')}`,
                     },
                  ]}
                  data={data.activityInRules}
                  options={{
                     headerStyle: headerStyle,
                     loadingType: 'linear',
                     tableLayout: 'fixed',
                     maxBodyHeight: 500,
                     padding: 'dense',
                     pageSize: 5,
                     pageSizeOptions: [5, 10, 25, 50, 100],
                  }}
                  icons={tableIcons}
               />
            </Box>
         </Box>
      </Paper>
   );
};

export default ViewTable;
